import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changePassword } from '../../redux/slices/settingsSlice';
import { toast } from 'react-toastify';
import './SecurityPanel.css';

const SecurityPanel = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.settings);
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password.length < 10) {
      toast.error('La contraseña debe tener mínimo 10 caracteres');
      return;
    }
    if (password !== passwordConfirm) {
      toast.error('Las contraseñas no coinciden');
      return;
    }
    
    dispatch(changePassword({ password, password_confirm: passwordConfirm })).unwrap().then(() => {
      toast.success('Contraseña administrativa actualizada con éxito');
      setPassword('');
      setPasswordConfirm('');
    }).catch((err) => {
      toast.error(err || 'Error al actualizar la contraseña');
    });
  };

  return (
    <div className="security-container">
      <div className="settings-header">
        <h1>Seguridad</h1>
        <p>Protege el acceso interno del equipo.</p>
      </div>

      <div className="security-grid">
        <div className="settings-card">
          <div className="card-header">
            <h2>Contraseña</h2>
            <p>Acceso administrativo</p>
          </div>

          <form onSubmit={handleSubmit} className="security-form">
            <div className="form-group">
              <label htmlFor="password">Nueva contraseña</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                minLength="10"
                required
                disabled={loading}
                autoComplete="new-password"
              />
            </div>

            <div className="form-group">
              <label htmlFor="passwordConfirm">Repite la contraseña</label>
              <input
                id="passwordConfirm"
                type="password"
                value={passwordConfirm}
                onChange={(e) => setPasswordConfirm(e.target.value)}
                minLength="10"
                required
                disabled={loading}
                autoComplete="new-password"
              />
            </div>

            <button type="submit" disabled={loading} className="btn btn-primary">
              {loading ? 'Actualizando...' : 'Actualizar contraseña'}
            </button>
          </form>
        </div>

        <aside className="security-notes">
          <h2>Protecciones activas</h2>
          <ul>
            <li>Acceso interno separado</li>
            <li>Contraseñas cifradas</li>
            <li>Protección CSRF</li>
            <li>Sesiones regeneradas</li>
            <li>Consultas preparadas</li>
            <li>Panel no indexable</li>
            <li>Límite de intentos de acceso</li>
            <li>Validación de archivos subidos</li>
          </ul>
        </aside>
      </div>
    </div>
  );
};

export default SecurityPanel;
